import getBrand from '../getBrand'

export const FETCH_KNOWLEDGEBASES = 'FETCH_KNOWLEDGEBASES'
export const FETCH_KNOWLEDGEBASES_FULFILLED = 'FETCH_KNOWLEDGEBASES_FULFILLED'
export const FETCH_KNOWLEDGEBASES_REJECTED = 'FETCH_KNOWLEDGEBASES_REJECTED'

const brand = process.env.REACT_APP_BRAND || getBrand()

const customerServiceEndpoint =
	brand === 'lexus'
		? 'https://osb.lexus.nl/customerservice'
		: 'https://osb.toyota.nl/customerservice'

export const fetchKnowledgeBases = (brand) => async (dispatch) => {
	dispatch({
		type: 'FETCH_KNOWLEDGEBASES',
	})

	try {
		const response = await fetch(`${customerServiceEndpoint}/knowledgebase/overview/${brand}`)
		const knowledgeBases = await response.json()

		dispatch({
			type: 'FETCH_KNOWLEDGEBASES_FULFILLED',
			knowledgeBaseFaq: knowledgeBases.knowledgeBaseFaq.knowledgeBases,
			knowledgeBaseTree: knowledgeBases.knowledgeBaseTree.knowledgeBases,
			knowledgeBaseFlatList: knowledgeBases.knowledgeBaseFlatList.knowledgeBases,
		})
	} catch (error) {
		dispatch({
			type: 'FETCH_KNOWLEDGEBASES_REJECTED',
			error: error,
		})
	}
}

export const sendAnswered = (nodeId) => async (dispatch) => {
	dispatch({
		type: 'SEND_RATING',
	})

	try {
		await fetch(`${customerServiceEndpoint}/knowledgebase/rating/${brand}`, {
			method: 'POST',
			body: JSON.stringify({
				version: 1,
				nodeIds: nodeId,
			}),
		})

		dispatch({
			type: 'SEND_RATING_FULFILLED',
		})
	} catch (error) {
		dispatch({
			type: 'SEND_RATING_REJECTED',
			error: error,
		})
	}
}

export const sendRating = (nodeId, comment) => async (dispatch) => {
	dispatch({
		type: 'SEND_RATING',
	})

	try {
		const data = {
			version: 1,
			rating: '1',
			nodeId,
			comment,
		}

		await fetch(`${customerServiceEndpoint}/knowledgebase/rating/${brand}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		dispatch({
			type: 'SEND_RATING_FULFILLED',
		})
	} catch (error) {
		dispatch({
			type: 'SEND_RATING_REJECTED',
			error: error,
		})
	}
}
